import React from 'react'
import VoteButton from './VoteButton';

export default function Vote2(props) {
    const { themeData } = props;

    const handleStatus = () => {
        switch (themeData.win){
            case "none": return (themeData && themeData.type === "end" ? "vote-end" : "");
            case "16cha": return "winner-16cha";
            case "calpis": return "winner-calpis";
            case "same": return "draw";
            default: return "";
        }
    }

    return (<>
        <div className="round round2"></div>
        <div className="vote-title title2"></div>
        <div className="vote-desc">
            <div>開始烤肉前，你想起了自己嚴格執行了好久的健康計畫，</div>
            <div>面對熊熊爐火，你發誓今晚你一定要......</div>
        </div>
        <div className={`vote-bg round2 ${handleStatus()}`}></div>
        <div className="vote-chat-container">
            <div className="vote-chat cha">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#好好睡決心</div>
                        <div className="desc">今晚，我絕對恪守零咖啡因守則，選擇十六茶，無論幾點烤完也要好好入睡到自然醒!</div>
                    </div>
                    <VoteButton voteType="cha" week="2">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
            <div className="vote-chat calpis">
                <div className="vote-chat-top"></div>
                <div className="vote-chat-content">
                    <div>
                        <div className="title">#好消化約定</div>
                        <div className="desc">今晚，吃再多也絕對不欺負我的腸胃，選擇「可爾必思」，讓乳酸菌助我邊烤邊消化!</div>
                    </div>
                    <VoteButton voteType="calpis" week="2">
                        <button className="common-btn pink" disabled={themeData && themeData.type !== "start" ? true : false}>{themeData && themeData.type === "end" ? "投票結束" : "投票"}</button>
                    </VoteButton>
                </div>
                <div className="vote-chat-bottom"></div>
            </div>
        </div>
    </>)
}